export default __webpack_public_path__ + "images/WY.3888e04.png";